<template>
    <CustomButton v-bind="$props" @click="$emit('click')">
        <font-awesome-icon v-if="icon" :icon="icon" class="icon" />
        <slot />
    </CustomButton>
</template>

<script>
import CustomButton from './Button';

export default {
    props: ['icon'],
    components: {
        CustomButton,
    },
};
</script>

<style lang="scss">
.icon {
    width: 15px;
    height: 15px;
    padding: 0px 7px;
}
</style>
